import React from 'react';
import style from './style';
import i18next from "i18next";
import EAButton from "../../../../components/common/EAButton";

const ProgressInfos = ({context, tpList, saveTiers}) => {
  const {classes} = style();
  return <div className={classes.root}>
    <div>
      <h2 className={classes.title}>
        {i18next.t('context.addTiers.add')}
      </h2>
      <h3 className={classes.subTitle}>
        {i18next.t('context.addTiers.tpSearch')}
      </h3>
      <p className={classes.text}>
        {i18next.t('context.addTiers.addTiersText')}
      </p>
    </div>
    <div className={classes.itemList}>
      <div className={classes.itemWrapper}>
        <div className={classes.itemTitle}>
          {i18next.t('context.addTiers.context')}
        </div>
        <div className={classes.item}>
          <div className={classes.contextWrapper}>
            <div className={classes.modelName}>{context.contextModelName}</div>
            <div className={classes.reference}>{context.reference}</div>
          </div>
        </div>
      </div>
      {tpList && tpList.length ? <div className={classes.itemWrapper}>
        <div className={classes.itemTitle}>
          {i18next.t('context.addTiers.associatedTp')}
        </div>
        <div className={classes.tiersList}>
          {tpList.map((tp) =>
              <div className={classes.item} key={tp.thirdPartyId}>
                <div className={classes.contextWrapper}>
                  <div className={classes.tpName}>{tp.tpInfos.name}</div>
                  <div className={classes.tpActivity}>{tp.tpInfos.activityLabel}</div>
                </div>
              </div>
          )}
        </div>
      </div> : <></>}
      {tpList && tpList.length ? <EAButton
          content={i18next.t('context.addTiers.terminerAjoutTiers')}
          colorVariant={"primaryLight"}
          onClick={saveTiers}
          customStyle={{
            width: 'fit-content',
            height: '40px',
            margin: '10px auto 0px auto',
            boxShadow: "none"
          }}
        />
        : <></>}
    </div>
  </div>
}

export default ProgressInfos;